import React, { useEffect, useState } from 'react'
import axios from 'axios';
// import AppStore from '../../Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import TestFlight from '../../TestFlight.png';
import CurateIcon from '../../Curate Icon.png';

function Main() {
  const [appStoreLink, setAppStoreLink] = useState({});

  useEffect(() => {
    // const oneLinkURL = "https://curatelife.onelink.me/HyHk";

    //   if (window.AF_SMART_SCRIPT) {
    //     const mediaSource = {keys: ["inmedia"], defaultValue: "web"};

    //     const link = window.AF_SMART_SCRIPT.generateOneLinkURL({
    //       oneLinkURL,
    //       afParameters: {
    //         mediaSource: mediaSource
    //       }
    //     });
    //     setAppStoreLink(link);
    //   } else {
    //     console.error('AF_SMART_SCRIPT is not loaded');
    //   }
  
    setAppStoreLink("https://testflight.apple.com/join/tJfnXtp6");
  },[])
  
  return (
    <div className="relative overflow-hidden">
      <div className="pt-10 pb-14 sm:pt-16 lg:overflow-hidden lg:pt-24 lg:pb-24">
        <div className="mx-auto max-w-5xl lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8">
            <div className="mx-auto max-w-md px-4 text-center sm:max-w-2xl sm:px-6 lg:flex lg:items-center lg:px-0 lg:text-left">
              <div className="lg:py-24">
                <h1 className="mt-4 text-6xl font-backGroove tracking-tight text-lightBlue sm:mt-5 sm:text-8xl lg:mt-6 md:text-8xl lg:text-9xl">Curate</h1>
                <h2 className="mt-4 text-4xl font-backGroove tracking-tight text-darkBlue sm:mt-5 sm:text-6xl lg:mt-6 md:text-6xl lg:text-7xl"><span className="inline-flex text-darkBlue">Your Space. Your Way.</span></h2>
                <p className="mt-3 text-base text-gray-800 sm:mt-5 sm:text-xl lg:text-2xl xl:text-3xl font-polliSansRegular">Exercise your creative side with Curate, the mobile design tool for the future of the mobile internet.</p>
              <div className="flex justify-center items-center p-4">
                  {/* <a href={appStoreLink.clickURL} target="_blank" rel="noreferrer"> */}
                  <a href={appStoreLink} target="_blank" rel="noreferrer" className="inline-block focus:outline-none">
                    <div className="mt-4 inline-flex flex-col items-center justify-center gap-4 rounded-2xl bg-lightBlue/10 px-6 py-4 shadow-sm hover:bg-lightBlue/20 hover:shadow-md transition focus:ring-2 focus:ring-lightBlue focus:ring-offset-2 overflow-hidden">
                      <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-backGroove tracking-tight text-darkBlue text-center leading-none w-full">Join the public beta!</span>
                      <div className="flex items-center gap-3 justify-center w-full">
                        <img className="h-14 sm:h-16 w-auto object-contain" src={TestFlight} alt="TestFlight"/>
                        <span className="text-3xl font-bold text-darkBlue">+</span>
                        <img className="h-14 sm:h-16 w-auto object-contain" src={CurateIcon} alt="Curate Logo"/>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="mt-12 md:inline-flex lg:block"><img src={require('../../screenshot.png')} alt="" /></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main

// onChange={(e) => setEmail(e.target.value)}